export { default } from "./DocDropzone";
